import React from 'react';
import cn from 'classnames';
import { View } from '@gin-betting/core';

import { GameLogo } from 'components';
import './topMatchTabs.scss';

interface Props {
    sports: View.Sport[];
    activeSportId: string;
    onTabChange: (sportId: string) => void;
    onInactiveTabHover: (sportId: string) => void;
}

const TopMatchTabs: React.FC<Props> = ({
    sports,
    activeSportId,
    onTabChange,
    onInactiveTabHover,
}) => {
    return (
        <div styleName="container">
            {sports.map(({ id, name }) => (
                <div
                    key={id}
                    styleName={cn('tab-item', {
                        'is-active ': id === activeSportId,
                    })}
                    title={name}
                    onClick={() => onTabChange(id)}
                    onMouseEnter={() =>
                        activeSportId !== id && onInactiveTabHover(id)
                    }
                >
                    <GameLogo gameId={id} />
                    {id === activeSportId && (
                        <div styleName="tab-title">{name}</div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default TopMatchTabs;
